import {
  validationObject,
  validateRequired,
  validateDuration,
  validateName,
  validateConditionallyIfRequired,
} from 'utils/validations';
import timezones from 'static/timezones.json';

import { intervalOptions } from 'mocks/utils';
import { getFormInitialValues, optionalFormField } from 'utils/methods/helpers';
// import { siteFields } from 'utils/SiteFormFields';
import { patrolFormFields } from 'utils/patrol';
import { SITE_POLICY_DEFAULT_VALUES } from 'utils/constants/visitor';
import {
  //   contactValidation,
  //   businessClientValidation,
  siteBaseValidation,
} from 'utils/validationSchema/index.js';
import { LOCATION_MODE, GEOGRAPHICAL_MAP } from 'utils/constants/Map';
import { serviceTypes } from 'utils/constants/serviceTypes';
import { EVIDENCE_PREFIX } from 'utils/constants/task';
import { transformEvidenceInitialValue } from 'utils/DataTransform/Task/taskForm';
import { PatrolDefInfo, SiteInfo } from 'utils/constants/informationText';
import { USER_FIELDS } from 'utils/formFields/user';
import SiteForm from 'containers/Pages/Locations/Sites/Layouts/baseSiteForm';
import API from 'services/api';
import { setSiteName } from 'utils/helper/site';
import isEmpty from 'lodash/isEmpty';
import { transform as siteListTransform } from 'utils/DataTransform/Sites/SitesList';
import { popupText } from 'utils/constants/popupText';

export const initialState = (timezone, mobilePatrolOnly) => ({
  archived: false,
  mobilePatrol: mobilePatrolOnly,
  expectedDuration: undefined,
  interval: undefined,
  patrolDefinitionName: undefined,
  site: {},
  checkpoints: undefined,
  startTime: undefined,
  endTime: undefined,
  schedule: undefined,
  timezone,
  newSite: false,
  returnToStart: true,
  newBusinessClient: false,
  siteSurfaceImages: GEOGRAPHICAL_MAP,
  ...SITE_POLICY_DEFAULT_VALUES,
});

export const initialValues = data => {
  const initialValues = getFormInitialValues(data);
  const { checkPointDetail } = initialValues;
  let locationEvidence = null;

  const newCheckpoints = checkPointDetail.map(({ evidence, ...checkpoint }) => {
    if (!evidence || evidence.length < 1) return checkpoint;

    const key = `${EVIDENCE_PREFIX}${checkpoint.seqNumber}`;
    if (!locationEvidence) {
      locationEvidence = {};
    }
    if (!locationEvidence[key]) {
      locationEvidence[key] = null;
    }

    const value = transformEvidenceInitialValue({ evidence });

    locationEvidence[key] = { ...checkpoint, value };
    return checkpoint;
  });

  if (checkPointDetail.length > 1) {
    // compare the first and the last value in the array
    if (
      checkPointDetail[0].lat ===
        checkPointDetail[checkPointDetail.length - 1].lat &&
      checkPointDetail[0].lng ===
        checkPointDetail[checkPointDetail.length - 1].lng
    ) {
      // add returnToStart flag to true
      initialValues.returnToStart = true;
    } else {
      // add returnToStart flag to false
      initialValues.returnToStart = false;
    }
  } else {
    initialValues.returnToStart = false;
  }

  return {
    ...initialValues,
    checkpoints: newCheckpoints,
    locationEvidence: locationEvidence,
  };
};
const baseValidation = {
  mobilePatrol: validateRequired(),
  checkpoints: validateRequired(),
  timezone: validateRequired(),
  patrolDefinitionName: validateName(30),
  expectedDuration: validateDuration(false, 4),
};

export const validationSchema = ({
  multisitePatrol,
  scheduledRequired,
  newSite,
  // newBusinessClient,
  // newContact,
  // newSiteContact,
}) => {
  let validation = baseValidation;
  if (!multisitePatrol) {
    newSite && Reflect.deleteProperty(siteBaseValidation, 'locations');
    validation = {
      ...validation,
      site: validateConditionallyIfRequired({
        conditionKey: 'newSite',
        conditionValue: false,
      }),
    };
  }

  if (scheduledRequired) {
    validation = {
      ...validation,
      interval: validateRequired(),
      startTime: validateRequired(),
      endTime: validateRequired(),
    };
  }

  return validationObject(validation);
};

export const mobilePatrolServices = [
  serviceTypes.patrol.singleSite,
  serviceTypes.patrol.multiSite,
];

export const generalSection = ({
  multisitePatrol,
  userAssignedDepartments,
  isMobilePatrolOnly,
  haveAllRequiredServices,
  isSurfaceImageMap,
  updatedValues,
  popUpRequired,
  sitesEnable = false,
  securityCompanyId,
  selectedDepartments,
}) => {
  const {
    mobilePatrol,
    patrolName,
    timezone,
    virtualPatrol,
  } = patrolFormFields;
  return [
    {
      ...mobilePatrol,
      disabled:
        !haveAllRequiredServices || isMobilePatrolOnly || !isSurfaceImageMap,
    },
    virtualPatrol({
      updateDependentField: [
        {
          key: 'returnToStart',
          value: false,
          condition: val => val,
        },
      ],
    }),
    patrolName,
    ...optionalFormField({
      showWhen: userAssignedDepartments.length > 0,
      field: USER_FIELDS.departments({ userAssignedDepartments }),
    }),
    timezone({ timezones, size: 'half' }),
    ...optionalFormField({
      showWhen: !isMobilePatrolOnly,
      field: {
        field: 'site',
        type: 'async-select',
        info: SiteInfo.businessClient,
        required: !multisitePatrol,
        disabled: multisitePatrol,
        popupRequired: popUpRequired, // if there are checkpoints. This si the condition on which the popup should be enabled
        popupMessages: {
          ...popupText.site,
        },
        resetRelatedFields: {
          // after the popup is removed, reset/assign the fields in formik to respective values
          checkpoints: [],
          location: [],
          additionalMarkers: [],
          siteSurfaceImages: GEOGRAPHICAL_MAP,
        },
        size: 'half',
        valueType: 'object',
        fetchOptions: API.fetchSitesList,
        fetchFilters: {
          securityCompanyId,
          archived: false,
          ...(!isEmpty(selectedDepartments) && {
            departmentId: selectedDepartments
              .map(m => ({ id: m.id }))
              .map(m => m.id),
          }),
        },
        optionLabelKey: 'name',
        resetWhen: [
          {
            value: selectedDepartments,
            condition: val => {
              return val;
            },
          },
        ],
        dataTransform: ({ data }) => {
          const transformedNameSites = data.map(site => ({
            ...site,
            id: site.id,
            name: setSiteName(site),
          }));
          return siteListTransform(
            transformedNameSites,
            userAssignedDepartments,
          );
        },
      },
    }),
    ...optionalFormField({
      showWhen: sitesEnable,
      field: {
        field: 'site', // this field name should be same as the one you are trying to replace value with
        type: 'embedded-form-follow-up',
        label: 'New Site',
        component: SiteForm,
        archiveDelete: true,
        updatedValues,
        hideTable: true,
        popUpRequired, // condition when popup should be activated
        disabled: multisitePatrol,
        popupMessages: {
          ...popupText.site,
        },
        setKeyValues: {
          checkpoints: [],
          site: {},
          siteSurfaceImages: GEOGRAPHICAL_MAP,
          locationDetail: [],
        }, // key values to set if pressed ok
        componentProps: {
          embeddedForm: true,
          disablePresist: true,
        },
      },
    }),
  ];
};
export const detailedSection = ({
  scheduledRequired,
  allDay,
  siteLocation,
  everyDay,
  selectedSiteDetailImages,
  multisitePatrol,
  siteSurfaces,
  isVirtualPatrolEnabled,
  selectedSite,
}) => {
  const {
    everyday,
    schedule,
    allDay: allDayField,
    startTime,
    endTime,
    interval,
    expectedDuration,
    checkpoints,
    checkpointsImage,
    returntostart,
    siteSurfaceImages,
  } = patrolFormFields;
  return [
    everyday,
    schedule({ disabled: everyDay }),
    allDayField,
    startTime({
      required: scheduledRequired,
      disabled: !scheduledRequired || allDay,
    }),
    endTime({
      required: scheduledRequired,
      disabled: !scheduledRequired || allDay,
    }),
    interval({
      options: intervalOptions,
      required: scheduledRequired,
      disabled: !scheduledRequired,
    }),
    expectedDuration,
    returntostart({ disabled: isVirtualPatrolEnabled }),
    siteSurfaceImages({
      options: siteSurfaces,
      useSelectedValue: true,
      valueType: 'object', // it will update whole selected option from dropdown object in the form props
      defaultValue: GEOGRAPHICAL_MAP,
      showPopup: true, // this field should show the popup incase the options are changed and surface is touched
      disabled: multisitePatrol,
      info: PatrolDefInfo.siteSurfaceImages,
      handleSelectChange: ({ e, handleChange, value, name }) => {
        e.target.value = value;
        e.target.name = name;
        handleChange(e);
      },
    }),
    ...optionalFormField({
      showWhen: selectedSiteDetailImages?.id === GEOGRAPHICAL_MAP.id,
      field: checkpoints({
        additionalPolygon: siteLocation,
        additionalPolygonMode: LOCATION_MODE.HIGH_DETAIL,
        displaySites: true, // it enable all the sites to be displayed on the map
        patrolEvidenceOptions: true, // This option will ensure that checkbox is included in patrols as evidence option
        secondaryDetail: selectedSite, // This object contains the selected site's centre of gravity for panning to location
      }),
    }),

    ...optionalFormField({
      showWhen:
        selectedSiteDetailImages &&
        selectedSiteDetailImages.id !== GEOGRAPHICAL_MAP.id,
      field: checkpointsImage({
        selectedSiteDetailImages,
      }),
    }),
  ];
};
